import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid, formataCurrency } from './../app.config';
import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';
import { ProdutoPacoteService } from '../produto-pacote/produto-pacote.service';
import { ProdutoPacote } from '../produto-pacote/produto-pacote.model';
import { PromocaoService } from '../promocao/promocao.service';
import { Promocao } from '../promocao/promocao.model';

@Component({
  selector: 'ntc-produto-promocao',
  templateUrl: './produto-promocao.component.html',
  styleUrls: ['./produto-promocao.component.css']
})
export class ProdutoPromocaoComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  editOptionsGridProdutoPromocao = null;
  colunasGridProdutoPromocao = null;
  produtoPromocao = null;
  listaProdutoPacote: ProdutoPacote[] = [];
  listaPromocao: Promocao[] = [];
  alturaGrid = null;
  listaStatusSelect = null;

  constructor(
    @Inject(Http) http: Http,
    private produtoPacoteService: ProdutoPacoteService,
    private promocaoService: PromocaoService
    ) {

    this.listaStatusSelect =  [
        {Nome: 'ProdutoPacote', Status: false},
        {Nome: 'Promocao', Status: false}
      ];

    this.produtoPromocao = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/produto-promocao/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/produto-promocao/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/produto-promocao/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/produto-promocao/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });

    this.editOptionsGridProdutoPromocao = {
      mode: GridConfig.gridMode, // form
      allowUpdating: true,
      allowAdding: true,
      allowDeleting: true,
      popup: {
        title: 'Produto Promoção',
        showTitle: true
      }
    };
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  montaColunasGrid = function (Grid = null){
    if (Grid !== null) {
      const foundItem = this.listaStatusSelect.find((fItem) => fItem.Nome === Grid);
      if (foundItem) {
        foundItem.Status = true;
      }
    }

    if (
      (this.listaStatusSelect[0].Status === true ) &&
      (this.listaStatusSelect[1].Status === true)
    ) {
      this.colunasGridProdutoPromocao = [
        {
          dataField: 'Id',
          dataType: 'string',
          caption: 'ID',
          editorOptions: { disabled: true }
        },
        {
          dataField: 'IdProdutoPacote',
          caption: 'Produto Pacote',
          lookup: {
              dataSource: this.listaProdutoPacote,
              displayExpr: 'DescricaoProdutoPacote',
              valueExpr: 'Id'
          },
          validationRules: [{
            type: 'required',
            message: 'Produto Pacote é obrigatório.'
          }]
        },
        {
          dataField: 'IdPromocao',
          caption: 'Promoção',
          lookup: {
              dataSource: this.listaPromocao,
              displayExpr: 'DescricaoPromocao',
              valueExpr: 'Id'
          },
          validationRules: [{
            type: 'required',
            message: 'Promoção é obrigatório.'
          }]
        },
        {
          dataField: 'DtCadastro',
          dataType: 'date',
          caption: 'Data do Cadastro',
          editorOptions: { disabled: true }
        },
        {
          dataField: 'ValorPromocao',
          dataType: 'number',
          caption: 'Valor',
          format: 'currency',
          editorOptions: {
            format: 'R$ #,##0.00'
          },
          validationRules: [{
            type: 'required',
            message: 'Valor é obrigatório.'
          }],
          customizeText: formataCurrency
        },
        {
          dataField: 'PrazoValidade',
          dataType: 'number',
          caption: 'Prazo de Validade',
          validationRules: [{
            type: 'required',
            message: 'Prazo de validade é obrigatório.'
          }]
        },
        {
          dataField: 'PrazoCortesiaPagamento',
          dataType: 'number',
          caption: 'Prazo de Cortesia - Pagamento',
          validationRules: [{
            type: 'required',
            message: 'Prazo de cortesia - pagamento é obrigatório.'
          }]
        },
        {
          dataField: 'PrazoCortesiaPacote',
          dataType: 'number',
          caption: 'Prazo de Cortesia - Pacote',
          validationRules: [{
            type: 'required',
            message: 'Prazo de cortesia - pacote é obrigatório.'
          }]
        },
        {
          dataField: 'IdProdutoPacoteCortesia',
          caption: 'Produto Pacote - Cortesia',
          lookup: {
              dataSource: this.listaProdutoPacote,
              displayExpr: 'DescricaoProdutoPacote',
              valueExpr: 'Id'
          }
        }
      ];
    }
  };

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
    this.produtoPacoteService.getProdutoPacote().subscribe(produtoPacote => {
      this.listaProdutoPacote = produtoPacote;
      this.montaColunasGrid('ProdutoPacote');
    }, error => {
      this.montaColunasGrid('ProdutoPacote');
    });

    this.promocaoService.getPromocoes().subscribe(promocoes => {
      this.listaPromocao = promocoes;
      this.montaColunasGrid('Promocao');
    }, error => {
      this.montaColunasGrid('Promocao');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/produto-promocao/produto-promocao.component.ts